module.exports = __webpack_public_path__ + "static/media/Anaconda.55aca690.svg";